import React from "react";
import SingleCountrySettingContent from "../components/countrySettings/single-countrySetting-content";

const SingleCountrySetting = () => {
  return <SingleCountrySettingContent />;
};

export default SingleCountrySetting;
